import React from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import ReportsTable from '../../components/ReportsTable/ReportsTable';
import { VIEWS_MAP } from '../utils/viewConfig';

/** Memoized view body — skips re-render when activeView and filteredReports are unchanged. */
const ViewContent = React.memo(function ViewContent({ activeView, filteredReports, loading, columns, onReportsRefresh }) {
    if (activeView === 'list') {
        return (
            <Stack p={2}>
                <ReportsTable reports={filteredReports} loading={loading} columns={columns} onRowChanged={onReportsRefresh} />
            </Stack>
        );
    }
    return (
        <Stack p={2}>
            <Typography color="text.secondary">
                {VIEWS_MAP.get(activeView) ?? 'Unknown'} — coming soon
            </Typography>
        </Stack>
    );
});

export default ViewContent;
